import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Organization, OrganizationService } from '@uzurv/clara';
import { isNullOrUndefined } from '@uzurv/core';
import { of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'uz-organization-select',
  templateUrl: './organization-select.component.html',
  styleUrls: ['./organization-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: OrganizationSelectComponent
    }
  ]
})
export class OrganizationSelectComponent implements OnInit, ControlValueAccessor {
  @ViewChild('filterInput') filterInput: ElementRef<HTMLInputElement>;
  @ViewChild('trigger') matAutocompleteTrigger: MatAutocompleteTrigger;

  @Input() organization: Organization;

  @Output() selectOrganization = new EventEmitter<Organization>();

  organizationSelect = new FormControl<Organization>(null);
  organizations: Array<Organization>;
  filteredOrganizations: Array<Organization>;

  onChange = (value: Organization) => {};

  onTouched = () => null;

  constructor(private organizationService: OrganizationService) {}

  writeValue(organization: Organization): void {
    this.organizationSelect.setValue(organization)
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit() {
    this.organizationService.listAll(0, 1000, true).subscribe(organizations => {
      this.organizations = organizations.sort((a: Organization, b: Organization) => (a.name.localeCompare(b.name)));
      this.filteredOrganizations = this.organizations.slice();
    });

    this.organizationSelect.valueChanges.pipe(
      filter(value => !isNullOrUndefined(value)),
      switchMap(value => typeof value === 'string' && value === '' ? of(null) : of(value)),
      map(value => {
        if (typeof value !== 'string') {
          this.selectOrganization.emit(value);
          this.onChange(value);
        } else {
          this.filterInput.nativeElement.value = value;
        }
      })
    ).subscribe();
  }

  filter() {
    let filterValue: string;
    if (this.organizationSelect.value instanceof Organization) {
      filterValue = ''
    } else {
      filterValue = this.filterInput.nativeElement.value.toLowerCase();
    }
    this.filteredOrganizations = this.organizations.filter(organization => (organization.code.toLocaleLowerCase() + organization.name.toLowerCase()).includes(filterValue));
  }

  getOrganizationText(organization: Organization): string {
    if (isNullOrUndefined(organization) || typeof organization === 'string') {
      return null;
    }

    return `${organization.name} (${organization.code})`
  }
}
